import React, { useState, useEffect } from 'react';
import {
  PageHeader, Result, Button, Row, Space
} from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import { Redirect } from 'react-router-dom';
import Spinner from 'components/Spins/Basic';
import Breadcrumb from 'components/BreadCrumb';
import { saveRecipe } from 'utils/recipes';
import { saveSpecification } from 'utils/specifications';
import DownLoadPDF from 'components/pdf/download';
import { sendSpecification } from 'utils/mails';
import ModalForm from 'containers/mailing/ModalFrom';
import SendCDC from 'containers/mailing/SendCDC';
import AuthenticatorWithEmail from 'utils/authentificator';

const Specifications = (props) => {
  const [specification, setSpecification] = useState(null);
  const [hasRecipeToSave, setRecipeToSave] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [recipe, setRecipe] = useState({});
  const [hasSpecificationToSave, setSpecificationToSave] = useState(false);
  const [wait, setWait] = useState(true);
  const { location: { state }, history } = props;

  useEffect(async () => {
    if (!_.isEmpty(state?.recipe)) {
      let newRecipe = {};
      if (!state.recipe.id) {
        newRecipe = await saveRecipe(state?.recipe);
        if (newRecipe?.data?.createFormula?.id) {
          setRecipe(newRecipe?.data?.createFormula);
          setRecipeToSave(true);
        }
      } else {
        setRecipe(state?.recipe);
      }
      const incomingRecipe = !state.recipe.id ? newRecipe?.data?.createFormula : state?.recipe;
      if (!_.isEmpty(state?.specification)) {
        const newSpecification = await saveSpecification(incomingRecipe, state?.specification);
        if (!_.isEmpty(newSpecification?.data?.createRequirement?.id)) {
          setSpecification(newSpecification?.data?.createRequirement);
          setSpecificationToSave(true);
        }
      }
    }
    setWait(false);
    history.replace({});
  }, []);

  const onFinish = async result => {
    console.log('in finish');
    await sendSpecification(recipe, specification.id, result);
    setIsModalVisible(false);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleGetSpecificationDetails = () => {
    history.replace({
      pathname: `/specification/${recipe?.id}/${specification?.id}/details`,
    });
  };

  const getSpecificationDetails = () => {
    if (!specification?.details) return false;
    const details = JSON.parse(specification?.details);
    return (
      <Row type="flex" align="space-around">
        <ModalForm Form={SendCDC} onFinish={onFinish} handleOk={handleOk} isModalVisible={isModalVisible} />
        <Space align="start" style={{ marginTop: '20px' }}>
          <Button type="primary" onClick={handleGetSpecificationDetails}>Voir les détails</Button>
          <Button type="primary" onClick={showModal}>Demander un devis</Button>
          <DownLoadPDF
            recipeIngredient={recipe?.ingredients}
            detailsSpecification={details}
            id={specification?.name}
            recipe={recipe?.name}
          />
        </Space>
      </Row>
    );
  };

  const renderNewlyCreatedItem = () => {
    if (wait) return <Spinner size="large" />;
    if (!hasRecipeToSave && !hasSpecificationToSave) return <Redirect to="/" />;
    let message = '';
    if (hasSpecificationToSave) {
      message += 'Votre cahier des charge a été enregistré !';
    }
    if (hasRecipeToSave) {
      message += `La recette ${recipe?.name} a été ajoutée à vos recettes !`;
    }
    return (
      <>
        <PageHeader
          style={{ border: '1px solid #d9d9d9' }}
          title="Mon cahier des charge"
          breadcrumb={(
            <Breadcrumb
              items={[
                ['Accueil', '/'],
                ['Mon cahier des charges'],
              ]}
            />
          )}
        />
        <InnerContent>
          <Result
            status="success"
            title={message}
          />
          {getSpecificationDetails()}
        </InnerContent>
      </>
    );
  };

  return (
    <AuthenticatorWithEmail>
      {renderNewlyCreatedItem()}
    </AuthenticatorWithEmail>
  );
};

Specifications.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      recipe: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        userId: PropTypes.string,
        ingredients: PropTypes.shape({
          condition: PropTypes.string,
          ingredient: PropTypes.string,
          themes: PropTypes.string
        })
      }),
      specification: PropTypes.shape({
        raccord1: PropTypes.string,
        raccord2: PropTypes.string,
        nep: PropTypes.string,
      })
    })
  }),
  history: PropTypes.shape({
    replace: PropTypes.func
  })
};

const InnerContent = styled.div`
  background: #fff;
  margin: 0px;
  margin-top: 20px;
`;

export default Specifications;
